export default {
      id: "ec_rep-usage",
      viewBox: "0 0 54 19",
      url: __webpack_public_path__ + "sprite.svg#ec_rep",
      toString: function () {
        return this.url;
      }
    }